module.exports = __webpack_public_path__ + "static/media/nothing.4c58037b.svg";